export const mapEmployeeProjectsDto = (dto) => ({
    id: dto.id,
    userId: dto.userId,
    title: dto.title,
    startDate: dto.startDate,
    endDate: dto.endDate,
    skills: dto.skills,
    description: dto.description,
    sortOrder: dto.sortOrder
});